import { minerQueryAsync, edataQueryAsync, minerUpdateAsync } from 'helpers/graphql'
import _ from 'lodash';
import {
  getCollection as getCollectionAction,
  getCollectionSuccess,
  fetchCollectionFeedSuccess,
  fetchCollectionAchiveSuccess,
} from './actions';
import clientId from 'clientId'

const fragment = `
  ... on News {
    globalId
    mediaType
    date
    title
    content
    from
    in
    images
    words
    score
    sentiment
    isTraditional
    url
  }
  ... on Print {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    downloadUrl
    url
  }
  ... on Youtube {
    globalId
    id
    mediaType
    date
    title
    content
    from
    by
    images
    words
    comments
    likes
    hits
    score
    url
    createdAt
    updatedAt
  }
  ... on Pixnet{
    globalId
    id
    mediaType
    date
    title
    content
    from
    in
    by
    images
    words
    comments
    hits
    score
    url
    createdAt
    updatedAt
  }
  ... on Forum {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    hits
    comments
    hotvalue
    words
    position
    score
    url
  }
  ... on Weibo {
    globalId
    id
    mediaType
    date
    title
    content
    from
    by
    images
    words
    comments
    likes
    shares
    score
    url
    createdAt
    updatedAt
  }
  ... on ForumComment {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    hits
    comments
    position
    words
  }
  ... on Blog {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    images
    words
    score
    url
  }
  ... on Video {
    globalId
    mediaType
    date
    title
    content
    from
    in
    words
    score
    url
    videoUrl
  }
  ... on Macautalk {
    globalId
    mediaType
    date
    title
    content
    from
    in
    by
    words
    score
  }
  ... on Facebook {
    globalId
    mediaType
    byImageUrl
    date
    content
    from
    fromId
    by
    likes
    comments
    shares
    hotvalue
    words
    score
    url
  }
  ... on Wechat {
    globalId
    mediaType
    date
    title
    content
    from
    by
    images
    hits
    likes
    words
    score
    url
  }
  ... on Twitter {
    globalId
    mediaType
    byImageUrl
    date
    content
    from
    by
    images
    likes
    shares
    words
    score
    url
    profileImageUrl
  }
  ... on Goods {
    globalId
    mediaType
    title
    content
    from
    in
    images
    averageScore
    price
    comments
    words
    score
    url
  }
  ... on Page {
    globalId
    id
    mediaType
    title
    content
    data
    from
    in
    by
    comments
    words
    score
    url
  }
`;

export const getCollection = (data) => {
  // const query = `
  //   query (
  //     $lastId: String
  //     $desc: Boolean
  //     $size: Int
  //     $userId: String!
  //   ) {
  //     clippings (
  //       lastId: $lastId
  //       desc: $desc
  //       size: $size
  //       clientId: "${clientId}"
  //       userId: $userId
  //     ) {
  //       count
  //       data {
  //         id
  //         globalId
  //         userId
  //         createdAt
  //       }
  //       lastId
  //     }
  //   }
  //   `
  // return minerQueryAsync(query, data)
  // .then((body) => {
  //   return getCollectionSuccess(body);
  // })
  const list = localStorage.collection;
  return getCollectionSuccess(JSON.parse(list || "{}"));
}

export const createdCollection = (data) => {
  const query = `
    mutation(
      $globalIds: [String!]!
    ) {
      createClipping(
        clientId: "${clientId}"
        globalIds: $globalIds
      )
    }
  `
  return minerUpdateAsync(query, {globalIds: data.globalIds})
  .then((body) => {
    return getCollectionAction({userId: data.userId})
  })
}

export const deleteCollection = (data) => {
  const query = `
    mutation(
      $ids: [String]
    ) {
      destroyClipping(
        ids: $ids
      )
    }
  `
  return minerUpdateAsync(query, {ids: data.ids})
  .then((body) => {
    return getCollectionAction({userId: data.userId})
  })
}

export const fetchCollectionFeed = (data) => {
  const query = `
    query(
      $globalId: [String]
    ){
      search (
        globalId: $globalId
        limit: 40
      ) {
        took
        count
        data {
          ${fragment}
        }
      }
    }
  `

  return edataQueryAsync(query, {...data})
  .then((body) => {
    return fetchCollectionFeedSuccess(body.data.search)
  });
}

export const setCollection = (data) => {
  //data.type --> ADD, DELETE, REMOVE, UPDATE
  const { type, globalId, list } = data;

  const _list = JSON.parse(localStorage.collection || "[]");
  let newList = []
  switch (type) {
    case 'ADD':
      newList = _.uniq([..._list, ...globalId]);
      break;
    case 'DELETE':
      newList = _.pullAll([..._list], globalId);
      break;
    case 'REMOVE':
      newList = [];
      break;
    case 'UPDATE':
      newList = list;
      break;
    default:
      newList = _list;
  }

  localStorage.collection = JSON.stringify(newList);
  return getCollectionAction()
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/collection/tasks.js
 **/